var React = require('react');

function IconReleases (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 6H4v2h16V6h-2zM4 4V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 2 2v2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2V6a2 2 0 0 1 2-2zm2 0h12V2H6v2zm14 6H2v12h20V10h-2z","fill":"currentColor","fillRule":"nonzero"}));
}

IconReleases.defaultProps = {"width":"24","height":"24"};

module.exports = IconReleases;

IconReleases.default = IconReleases;
